import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createBitcoinNetworkProvider } from '../utils/createBitcoinNetworkProvider';

export const registerBitcoinNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  /**
   * If the Bitcoin network provider builder is already registered, return.
   */
  if (networkProviderBuilderRegistry.get().get('BTC')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createBitcoinNetworkProvider,
    chain: 'BTC',
  });
};
